module.exports = __webpack_public_path__ + "media/marker/map-pin-323eded6.png";